import { render, staticRenderFns } from "./reservation-archive-restore.vue?vue&type=template&id=aff8de1a&scoped=true"
import script from "./reservation-archive-restore.vue?vue&type=script&lang=js"
export * from "./reservation-archive-restore.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "aff8de1a",
  null
  
)

export default component.exports